var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7778,
    height: 41.7778,
    rx: 20,
    fill: "#6EE796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1852 17.4073V29.5925",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1482 22.6296V29.5925M19.1482 22.6296C19.1482 19.7453 21.4862 17.4073 24.3704 17.4073C27.2546 17.4073 29.5926 19.7453 29.5926 22.6296V29.5925M19.1482 22.6296V17.4073",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 12.1852H12.1835",
    stroke: "black",
    strokeWidth: 3.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35187 20.8888C4.35187 13.0932 4.35187 9.1954 6.77366 6.77359C9.19546 4.35181 13.0933 4.35181 20.8889 4.35181C28.6845 4.35181 32.5823 4.35181 35.0042 6.77359C37.4259 9.1954 37.4259 13.0932 37.4259 20.8888C37.4259 28.6844 37.4259 32.5823 35.0042 35.0042C32.5823 37.4259 28.6845 37.4259 20.8889 37.4259C13.0933 37.4259 9.19546 37.4259 6.77366 35.0042C4.35187 32.5823 4.35187 28.6844 4.35187 20.8888Z",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.18e940d9ac0fee1bd13242abd7776828.svg";
export { ForwardRef as ReactComponent };